
import { computed, defineComponent } from 'vue';
import { useStore } from 'src/store';
import { getSignInUrl } from 'src/services/routing';

export default defineComponent({
  name: 'Login',
  setup() {
    const $store = useStore();
    const user = computed(() => $store.getters['app/user']);
    const isLoggedIn = computed(() => $store.getters['app/isLogged']);

    return {
      user,
      isLoggedIn,
      azureUrl: computed(() => getSignInUrl($store.state.app.host)),
    };
  },
});
